module.exports = __webpack_public_path__ + "static/media/isophya_camptoxypha_BD_020_APA.d47310bd.png";